<template>
  <div>
    <b-form-row>
      <b-col class="mb-2">
        <b-button @click="showFluxoCaixa" size="sm" variant="success"
          ><i class="fas fa-sync"></i> Atualizar Lista</b-button
        >
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-table
          hover
          bordered
          small
          responsive
          no-border-collapse
          striped
          foot-clone
          primary-key="desembolso_id"
          table-class="font08 table-border"
          thead-class="table-header"
          selectable
          sticky-header="300px"
          select-mode="single"
          selected-variant="primary"
          head-variant="dark"
          empty-text="Sem dados para exibir"
          empty-filtered-text="Sem dados para exibir"
          show-empty
          :fields="campos"
          :items="fluxoCaixa"
        >
          <template #thead-top="">
            <b-tr class="top-header" style="position: sticky;">
              <b-th colspan="8">PLANEJAMENTO / EXECUÇÃO</b-th>
              <b-th colspan="7">ACUMULADO</b-th>
            </b-tr>
          </template>

          <template v-slot:cell(mes)="data">
            {{ `${String(data.item.mes).padStart(2, "0")}/${data.item.ano}` }}
          </template>
          <template v-slot:foot(mes)><span>TOTAL</span></template>
          <template v-slot:foot(vl_planejado_m2)
            ><span>{{ getTotalPlanejadoM2 }}</span></template
          >
          <template v-slot:foot(vl_desembolso_m2)
            ><span>{{ getTotalDesembolsoM2 }}</span></template
          >
          <template v-slot:foot(vl_pago_m2)
            ><span>{{ getTotalPagoM2 }}</span></template
          >
          <template v-slot:foot(vl_reconhecido_m2)
            ><span>{{ getTotalReconhecidoM2 }}</span></template
          >
          <template v-slot:foot(vl_pago_a_reconhecer_m2)
            ><span>{{ getTotalPagoAReconhecerM2 }}</span></template
          >
          <template v-slot:foot(vl_a_reconhecer_m2)
            ><span>{{ getTotalAReconhecerM2 }}</span></template
          >

          <template v-slot:foot(perc_atingido)
            ><span>{{ getTotalPercAtingidoM2 }}</span></template
          >
          <!-- ACUMULADO -->
          <template v-slot:foot(vl_planejado_m2_acm)
            ><span>{{ getTotalPlanejadoM2Acm }}</span></template
          >
          <template v-slot:foot(vl_desembolso_m2_acm)
            ><span>{{ getTotalDesembolsoM2Acm }}</span></template
          >
          <template v-slot:foot(vl_pago_m2_acm)
            ><span>{{ getTotalPagoM2Acm }}</span></template
          >
          <template v-slot:foot(vl_reconhecido_m2_acm)
            ><span>{{ getTotalReconhecidoM2Acm }}</span></template
          >
          <template v-slot:foot(vl_pago_a_reconhecer_m2_acm)
            ><span>{{ getTotalPagoAReconhecerM2Acm }}</span></template
          >
          <template v-slot:foot(vl_a_reconhecer_m2_acm)
            ><span>{{ getTotalAReconhecerM2Acm }}</span></template
          >
        </b-table>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import { formatMoney } from "@/global";

import axios from "axios";
import { baseApiUrl, showError } from "@/global";

export default {
  name: "SubTabFluxoCaixa",
  computed: {
    getTotalDesembolso: function() {
      let valor = this.fluxoCaixa.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_desembolso);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalPlanejado: function() {
      let valor = this.fluxoCaixa.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_planejado);
      }, 0.0);

      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalPago: function() {
      let valor = this.fluxoCaixa.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_pago_m2);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalReconhecido: function() {
      let valor = this.fluxoCaixa.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_reconhecido_m2);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalAReconhecer: function() {
      let valor = this.fluxoCaixa.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_a_reconhecer_m2);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalPagoAReconhecer: function() {
      let valor = this.fluxoCaixa.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_pago_a_reconhecer_m2);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },

    //*****************************/
    //******* M2 ******************/
    //*****************************/

    getTotalDesembolsoM2: function() {
      let valor = this.fluxoCaixa.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_desembolso_m2);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalPlanejadoM2: function() {
      let valor = this.fluxoCaixa.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_planejado_m2);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalPagoM2: function() {
      let valor = this.fluxoCaixa.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_pago_m2);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalReconhecidoM2: function() {
      let valor = this.fluxoCaixa.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_reconhecido_m2);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalAReconhecerM2: function() {
      let valor = this.fluxoCaixa.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_a_reconhecer_m2);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalPagoAReconhecerM2: function() {
      let valor = this.fluxoCaixa.reduce((accum, item) => {
        return parseFloat(accum) + parseFloat(item.vl_pago_a_reconhecer_m2);
      }, 0.0);
      return formatMoney(valor, 2, "", ".", ",");
    },
    getTotalPercAtingidoM2: function() {
      let _valor = 0;
      if (this.fluxoCaixa.length == 0) _valor = 0;
      else {
        let ultimaLinha = this.fluxoCaixa[this.fluxoCaixa.length - 1];
        _valor = ultimaLinha.perc_atingido;
      }

      return formatMoney(_valor, 2, "", ".", ",");
    },
    //***************************************/
    //******* ACUMULADO M2 ******************/
    //***************************************/

    getTotalDesembolsoM2Acm: function() {
      let _valor = 0;
      if (this.fluxoCaixa.length == 0) _valor = 0;
      else {
        let ultimaLinha = this.fluxoCaixa[this.fluxoCaixa.length - 1];
        _valor = ultimaLinha.vl_desembolso_m2_acm;
      }

      return formatMoney(_valor, 2, "", ".", ",");
    },
    getTotalPlanejadoM2Acm: function() {
      let _valor = 0;
      if (this.fluxoCaixa.length == 0) _valor = 0;
      else {
        let ultimaLinha = this.fluxoCaixa[this.fluxoCaixa.length - 1];
        _valor = ultimaLinha.vl_planejado_m2_acm;
      }

      return formatMoney(_valor, 2, "", ".", ",");
    },
    getTotalPagoM2Acm: function() {
      let _valor = 0;
      if (this.fluxoCaixa.length == 0) _valor = 0;
      else {
        let ultimaLinha = this.fluxoCaixa[this.fluxoCaixa.length - 1];
        _valor = ultimaLinha.vl_pago_m2_acm;
      }

      return formatMoney(_valor, 2, "", ".", ",");
    },
    getTotalReconhecidoM2Acm: function() {
      let _valor = 0;
      if (this.fluxoCaixa.length == 0) _valor = 0;
      else {
        let ultimaLinha = this.fluxoCaixa[this.fluxoCaixa.length - 1];
        _valor = ultimaLinha.vl_reconhecido_m2_acm;
      }

      return formatMoney(_valor, 2, "", ".", ",");
    },
    getTotalAReconhecerM2Acm: function() {
      let _valor = 0;
      if (this.fluxoCaixa.length == 0) _valor = 0;
      else {
        let ultimaLinha = this.fluxoCaixa[this.fluxoCaixa.length - 1];
        _valor = ultimaLinha.vl_a_reconhecer_m2_acm;
      }

      return formatMoney(_valor, 2, "", ".", ",");
    },
    getTotalPagoAReconhecerM2Acm: function() {
      let _valor = 0;
      if (this.fluxoCaixa.length == 0) _valor = 0;
      else {
        let ultimaLinha = this.fluxoCaixa[this.fluxoCaixa.length - 1];
        _valor = ultimaLinha.vl_pago_a_reconhecer_m2_acm;
      }

      return formatMoney(_valor, 2, "", ".", ",");
    },
  },
  props: {
    programa: { type: Object, required: true },
    acao: { type: String, required: true },
  },
  data: function() {
    return {
      fluxoCaixa: [],
      campos: [
        {
          key: "mes",
          label: "Mês/Ano",
          stickyColumn: true,
          isRowHeader: true,
        },
        {
          key: "vl_planejado_m2",
          class: "text-right",
          label: "Planejado",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_desembolso_m2",
          class: "text-right",
          label: "Desembolsado",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_pago_m2",
          class: "text-right",
          label: "Pago",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_reconhecido_m2",
          class: "text-right",
          label: "Reconhecido",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_pago_a_reconhecer_m2",
          class: "text-right",
          label: "Pago a Reconhecer",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_a_reconhecer_m2",
          class: "text-right",
          label: "Desembolsado a Reconhecer",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "perc_atingido",
          class: "text-right",
          label: "% Atigindo",
          variant: "info",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        // acumulados linha a linha
        {
          key: "vl_planejado_m2_acm",
          class: "text-right",
          label: "Planejado",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_desembolso_m2_acm",
          class: "text-right",
          label: "Desembolsado",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_pago_m2_acm",
          class: "text-right",
          label: "Pago",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_reconhecido_m2_acm",
          class: "text-right",
          label: "Reconhecido",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_pago_a_reconhecer_m2_acm",
          class: "text-right",
          label: "Pago a Reconhecer",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        {
          key: "vl_a_reconhecer_m2_acm",
          class: "text-right",
          label: "Desembolsado a Reconhecer",
          formatter: (val) => {
            return formatMoney(val, 2, "", ".", ",");
          },
        },
        // {
        //   key: "perc_atingido_acm",
        //   class: "text-right",
        //   label: "% Atigindo",
        //   formatter: (val) => {
        //     return formatMoney(val, 2, "", ".", ",");
        //   },
        // },
      ],
    };
  },
  methods: {
    showFluxoCaixa() {
      //this.fluxoCaixa = this.programa.fluxoCaixa;
      this.refreshFluxoCaixa();
    },
    refreshFluxoCaixa() {
      axios
        .get(
          `${baseApiUrl}/bid/programas/fluxo-caixa/${btoa(
            this.programa.programa_id
          )}`
        )
        .then((resp) => {
          this.fluxoCaixa = resp.data;
        })
        .catch((ex) => {
          showError(ex);
        });
    },
  },
  mounted() {
    this.showFluxoCaixa();
  },
};
</script>

<style>
.top-header th {
  background-color: #4c545b !important;
  text-align: center;
  border-bottom: none !important;
}

.table-header th {
  border-color: #aaa !important;
}

.accum-col {
  background-color: #efefef;
}

.accum-col:hover {
  color: #333 !important;
}

.table-border td {
  border-color: #ccc !important;
}
</style>
